import { render, staticRenderFns } from "./StatementReport.vue?vue&type=template&id=1f82b4ef&scoped=true"
import script from "./StatementReport.vue?vue&type=script&lang=js"
export * from "./StatementReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82b4ef",
  null
  
)

export default component.exports